import * as React from 'react';
import * as styles from './CianInfo.css';
import { ISeller } from '../../types/newbuilding';
import { Avatar, UIHeading4 } from '@cian/ui-kit';
import { NO_BREAK_SPACE } from '../../constants/symbolsUnicode';

interface ICianInfoProps {
  sellers: ISeller[];
}

export const CianInfo: React.FC<ICianInfoProps> = ({ sellers }) => {
  const leadFactorySeller = React.useMemo(() => {
    return sellers.find(seller => seller.isLeadFactory);
  }, [sellers]);

  if (!leadFactorySeller) {
    return null;
  }

  return (
    <div data-testid="CianInfo">
      <div className={styles['avatar']}>
        <Avatar type="builder" size={64} src={leadFactorySeller.avatarUrl} hideBorder />
      </div>
      <div className={styles['name']}>
        <UIHeading4>{leadFactorySeller.name}</UIHeading4>
        <UIHeading4 color="text-secondary-default">Консультант по{NO_BREAK_SPACE}новостройкам</UIHeading4>
      </div>
    </div>
  );
};
